import React, {useState, useRef} from 'react';
import {LeftOutlined, RightOutlined} from '@ant-design/icons';

const Gallery = ({images}) => {
    const [previewImage, setPreviewImage] = useState(null);
    const galleryRef = useRef(null);

    const handleImageClick = (src) => {
        setPreviewImage(src); // Set the clicked image as the preview image
    };

    const closePreview = () => {
        setPreviewImage(null); // Close the preview by setting the preview image to null
    };

    const scrollLeft = () => {
        galleryRef.current.scrollBy({left: -300, behavior: 'smooth'});
    };

    const scrollRight = () => {
        galleryRef.current.scrollBy({left: 300, behavior: 'smooth'});
    };

    return (
        <>
            <div className="relative">
                {/* Left navigation button */}
                <button
                    onClick={scrollLeft}
                    className="hidden lg:flex absolute left-0 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-lg z-10"
                >
                    <LeftOutlined className="text-black" />
                </button>

                {/* Image gallery */}
                <div
                    ref={galleryRef}
                    className="flex overflow-x-scroll space-x-4 p-4 scrollbar-hide" // Tailwind class to hide scrollbar
                >
                    {images.map((src, index) => (
                        <img
                            key={index}
                            src={src}
                            alt={`gallery-img-${index}`}
                            onClick={() => handleImageClick(src)}
                            className="w-48 h-48 md:w-96 md:h-96 object-cover aspect-square rounded-[26px] lg:rounded-[36px] cursor-pointer"
                        />
                    ))}
                </div>

                {/* Right navigation button */}
                <button
                    onClick={scrollRight}
                    className="hidden lg:flex absolute right-0 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-lg z-10"
                >
                    <RightOutlined className="text-black" />
                </button>
            </div>

            {/* Preview Modal */}
            {previewImage && (
                <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
                    <div className="relative max-w-full max-h-full p-4">
                        <img
                            src={previewImage}
                            alt="Preview"
                            className="max-w-[90vw] max-h-[90vh] w-auto h-auto object-contain rounded-lg"
                        />
                        <button
                            onClick={closePreview}
                            className="absolute top-2 right-2 bg-white text-black rounded-full p-2"
                        >
                            ✖
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default Gallery;
